module.exports = __webpack_public_path__ + "img/pwb.b7655ec2.png";